<template>
  <div>
    <v-btn-toggle v-model="status" :color="statusInfo[status].color" tile group dense shaped class="flex-wrap">
      <v-btn
        v-for="status in statusArray"
        :key="status.value"
        :value="status.value"
        :color="status.color"
        x-small
        outlined
      >
        {{ status.label }}
      </v-btn>
    </v-btn-toggle>
    <v-row class="p-1">
      <v-col>
        <div class="caption w-100 text-center pl-5 pb-2">
          {{ value.current_week_start }} ... {{ value.current_week_end }}
        </div>
        <VueSchedule
          v-model="currentWeek"
          str-week=""
          str-day="День"
          :status="status"
          dense
        />
      </v-col>
      <v-col>
        <div class="caption w-100 text-center pl-5 pb-2">
          {{ value.next_week_start }} ... {{ value.next_week_end }}
        </div>
        <VueSchedule
          v-model="nextWeek"
          str-week=""
          str-day="День"
          :status="status"
          dense
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  STATUS_INFO,
  STATUS_AVAILABLE,
  STATUS_VACATION,
  STATUS_LEAVING,
  STATUS_MOVED,
  STATUS_ILL,
  STATUS_NEGATIVE,
  STATUS_LOST,
  STATUS_FIRE,
  STATUS_BUSY,
} from '~schedule/statuses';

// @ts-ignore
import VueSchedule from '~schedule/Schedule.vue';
// import Data from '~/interfaces/Data'
export default {
  name: 'ScheduleTable',
  components: {
    VueSchedule,
  },
  props: {
    value: {
      type: Object,
      required: true,
      /* validator: val => Object.keys(val.current_week).length === 7 &&
        Object.keys(val.current_week).length === 7 */
    },
    uuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      statusInfo: STATUS_INFO,
      statusArray: [
        STATUS_INFO[STATUS_AVAILABLE],
        STATUS_INFO[STATUS_NEGATIVE],
        STATUS_INFO[STATUS_LOST],
        STATUS_INFO[STATUS_FIRE],
        STATUS_INFO[STATUS_LEAVING],
        STATUS_INFO[STATUS_VACATION],
        STATUS_INFO[STATUS_MOVED],
        STATUS_INFO[STATUS_ILL],
        STATUS_INFO[STATUS_BUSY],
      ],
      status: STATUS_AVAILABLE,
      // currentWeek: this.value.current_week,
      // nextWeek: this.value.next_week
    };
  },
  computed: {
    currentWeek: {
      get() {
        return this.value.current_week;
      },
      set(newValue) {
        this.$emit('input', {
          uuid: this.uuid,
          currentWeek: newValue,
          nextWeek: this.nextWeek,
        });
      },
    },
    nextWeek: {
      get() {
        return this.value.next_week;
      },
      set(newValue) {
        this.$emit('input', {
          uuid: this.uuid,
          currentWeek: this.currentWeek,
          nextWeek: newValue,
        });
      },
    },
  },
  methods: {
    /* onChangeCurrentWeek(val) {
      this.$emit('input', {
        currentWeek: val,
        nextWeek: this.nextWeek
      });
    },
    onChangeNextWeek(val) {
      this.$emit('input', {
        currentWeek: val,
        nextWeek: this.nextWeek
      });
    } */
  },
};
</script>
<style lang="scss"></style>
